import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as EnglishFlag } from "assets/english.svg";
import { ReactComponent as FrenchFlag } from "assets/french.svg";

const LanguageSwitcher = () => {
  const [isFrenchActive, setFrenchActive] = useState(false);
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const savedLanguage = localStorage.getItem("selectedLanguage");

    if (savedLanguage) {
      setFrenchActive(savedLanguage === "fr");
      i18n.changeLanguage(savedLanguage);
    }
  }, [i18n]);

  const toggleLanguage = () => {
    setFrenchActive(!isFrenchActive);
    const newLanguage = isFrenchActive ? "en" : "fr";
    i18n.changeLanguage(newLanguage);
    localStorage.setItem("selectedLanguage", newLanguage);
  };

  return (
    <div className="relative z-40">
      <div className="group inline-block">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="border-none h-12 max-md:h-9 w-fit px-3 max-md:px-1.5 flex items-center justify-between gap-2.5 max-md:gap-1.5 outline-none focus:outline-none"
        >
          {isFrenchActive ? <FrenchFlag /> : <EnglishFlag />}
          <div className="flex items-center justify-start gap-1.5 max-md:gap-1">
            <span className={`text-sm`}>
              {isFrenchActive ? "French" : "English"}
            </span>

            <span className="">
              <svg
                width="10"
                height="6"
                viewBox="0 0 10 6"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.799988 0.800003L4.79999 4.8L8.79999 0.800003"
                  stroke="black"
                  stroke-opacity="0.4"
                  stroke-width="1.6"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
          </div>
        </button>
        <div className="">
          <ul
            className={`font-lexend transform scale-0 group-hover:scale-100 ${
              isOpen ? "" : ""
            } absolute transition duration-150 ease-in-out w-[180px] px-5 py-5 mt-2 origin-top rounded-[10px] bg-white font-[PoppinsSemibold] text-black space-y-4`}
          >
            <div className="flex items-center justify-start gap-2 border border-[#F4C5E6] bg-[#FFE5F7B2] rounded-[10px] px-4 py-4 z-40 min-w-20 pointer-events-none text-sm max-md:text-[14px]">
              {isFrenchActive ? (
                <FrenchFlag className="max-md:w-4 max-md:h-4" />
              ) : (
                <EnglishFlag className="max-md:w-4 max-md:h-4" />
              )}
              {isFrenchActive ? "French" : "English"}
            </div>
            <div
              className="flex items-center justify-start gap-2 border border-[#F1F1F1] rounded-[10px] bg-white px-4 py-4 z-40 min-w-20 cursor-pointer text-sm max-md:text-[14px]"
              onClick={toggleLanguage}
            >
              {isFrenchActive ? (
                <EnglishFlag className="max-md:w-4 max-md:h-4" />
              ) : (
                <FrenchFlag className="max-md:w-4 max-md:h-4" />
              )}
              {isFrenchActive ? "English" : "French"}
            </div>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default LanguageSwitcher;
